<main id="pricings" [ngClass]="{'isFullscreen': this.isOperator === false}" *ngIf="isLoaded; else loading">
  <div class="active card">
    <div class="card-header">
      <h5><app-svg source="icons/feather/coins" height="18" i18n="@@InvoicePricingHeader"></app-svg>Manuelle Rechnungsstellung
      </h5>
      <h5><app-svg source="icons/feather/help-circle" height="18" [ngbTooltip]="tooltipContentManuellBilling"
          tooltipClass="tooltip custom-tooltip"></app-svg>
        <ng-template #tooltipContentManuellBilling>
          <div class="tooltip-content">
            Bei der manuellen Rechnungsstellung erfolgt die Rechnungsstellung bei Bedarf. Ab dem Moment der Zuteilung des
            Tarifs an einen Benutzer listet CUBOS.Connect alle offenen Rechnungsposten auf. Sie bestimmen, wann Sie eine
            Rechnung für den Benutzer erzeugen möchten und kontrollieren die Rechnungsdaten.
            <ul>
              <li>Sie können jedem Benutzer nur einen Tarif gleichzeitig zuweisen. Aber Sie können beliebig viele Tarife
                gleichzeitig haben und Sie können einem Tarif mehrere Benutzer hinzufügen.</li>
            </ul>
          </div>
        </ng-template>
      </h5>
    </div>
    <div class="card-body">
      <div class="pricings">
        <div *ngFor="let pricing of activeInvoicePricings" class="pricing" [routerLink]="'edit/' + pricing.id">
          <h2>{{ pricing.name }}</h2>
          <div class="prices d-flex gap-4">
            <div class="price ac"><span>AC</span>€&nbsp;{{ pricing.price | number: '1.2-2':'de-DE' }}</div>
            <div class="price dc"><span>DC</span>€&nbsp;{{ pricing.priceDc | number: '1.2-2':'de-DE' }}</div>
          </div>
          <p>{{ pricing.description }}</p>
          <span class="users">
            <app-svg source="icons/feather/users" height="18"></app-svg>
            {{pricing.selectedUsers.length || 0 }}
          </span>
        </div>
        <!-- <div class="pricing" [routerLink]="['create']" (click)="setPricingType('Rechnung')"> -->
        <div class="pricing" (click)="isSupporter? null : setPricingType('Rechnung')" id="add_manuellbilling_pricing">
          <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Automatische Monatsabrechnung -->
  <div class="active card">
    <div class="card-header">
      <h5 i18n="@@SubscriptionPricingHeader" *ngIf="isOnboardingCompleted && isInvoiceSettingsValid">
        <app-svg source="icons/feather/credit-card" height="18"></app-svg>Automatische Monatsabrechnung
      </h5>
      <h5 i18n="@@SubscriptionAndQrCodePricingHeader" *ngIf="!isOnboardingCompleted || !isInvoiceSettingsValid">
        <app-svg source="icons/feather/credit-card" height="18"></app-svg>Automatische Monatsabrechnung&emsp;|&ensp;<app-svg
          source="icons/feather/qr-code" height="18"></app-svg>QR-Code
      </h5>
      <h5 *ngIf="!isOnboardingCompleted || !isInvoiceSettingsValid"></h5>
      <h5 *ngIf="isOnboardingCompleted && isInvoiceSettingsValid">
        <app-svg source="icons/feather/help-circle" height="18" i18n="@@SubscriptionPricingTooltip"
          [ngbTooltip]='tooltipContentAutoBilling' tooltipClass="tooltip custom-tooltip"></app-svg>
        <ng-template #tooltipContentAutoBilling>
          <div class="tooltip-content">
            Bei der automatischen Monatsabrechnung erfolgen Rechnungsstellung und Abbuchung automatisch bei jedem
            Monatswechsel durch CUBOS.Connect. Benutzer zahlen wahlweise mit Kreditkarte, Apple Pay, Google Pay,
            SEPA-Lastschrift oder PayPal.
            <ul>
              <li>Der zu zahlende Mindestbetrag für die Automatische Monatsabrechnung beträgt 1 Euro.</li>
              <li>Der von Ihnen gewählte Tarif ist der Preis pro kWh inkl. Mehrwertsteuer, der auch dem Nutzer berechnet
                wird.</li>
              <li>Sie können jedem Benutzer nur einen Tarif gleichzeitig zuweisen. Aber Sie können beliebig viele Tarife
                gleichzeitig haben und Sie können einem Tarif mehrere Benutzer hinzufügen.</li>
              <li>Sie sollten etwa 30% auf Ihren Netto-Stromkostenbetrag aufschlagen, wenn Sie einen Tarif zum
                Selbstkostenpreis anbieten möchten.</li>
              <li><b>Wenn Sie einen Tarif an einen Benutzer zugeteilt haben, warten Sie bis auf der Seite Benutzer in
                  der Spalte "Autom. Abrechnung" ein Haken erscheint. Autorisieren Sie den Benutzer erst danach an den
                  Ladestationen.</b>
              </li>
            </ul>
          </div>
        </ng-template>
      </h5>
    </div>

    <div class="card-body">
      <div>
        <div *ngIf="isOnboardingCompleted && isInvoiceSettingsValid" class="pricings">
          <div *ngFor="let pricing of activeAbonnementPricings" class="pricing" [routerLink]="'edit/' + pricing.id">
            <!-- <ng-container *ngTemplateOutlet="pricing" [ngTemplateOutletContext]="{pricing: pricing}"></ng-container> -->
            <h2>{{ pricing.name }}</h2>
            <div class="prices d-flex gap-4">
              <div class="price ac"><span>AC</span>€&nbsp;{{ pricing.price | number: '1.2-2':'de-DE' }}</div>
              <div class="price dc"><span>DC</span>€&nbsp;{{ pricing.priceDc | number: '1.2-2':'de-DE' }}</div>
            </div>
            <p>{{ pricing.description }}</p>
            <span class="users">
              <app-svg source="icons/feather/users" height="18"></app-svg>
              {{pricing.selectedUsers.length || 0 }}
            </span>
          </div>
          <div class="pricing" (click)="isSupporter? null : setPricingType('Abonnement')" id="add_autobilling_pricing">
            <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
          </div>
        </div>
        <div *ngIf="!isOnboardingStarted">
          <h2 i18n="@@StartSetupHeader">Zahlungsdienstleister einrichten</h2>
          <p i18n="@@StripeOnboardingMessage">Für einen sicheren Geldverkehr arbeiten wir mit dem Zahlungsdienstleister
            Stripe zusammen. Führen Sie das Stripe Onboarding durch und erstellen Sie anschließend individuelle Tarife.
          </p>
          <p i18n="@@StripeOnboardingInfoPrepareMessage">Das Onboarding dauert wenige Minuten. Bitte halten Sie Ihre
            Unternehmensdaten, Geschäftskontodaten und personenbezogene Daten zum Geschäftsführer bereit.</p>
        </div>

        <div *ngIf="isOnboardingStarted && !isOnboardingCompleted || isOnboardingCompleted && !isInvoiceSettingsValid">
          <h2 i18n="@@CompleteSetupHeader">Einrichtung abschließen</h2>
          <p>Fast geschafft! Um die Automatische Abrechnung und QR-Code-Laden nutzen zu können, benötigen wir nur noch
            wenige Angaben.</p>
        </div>

        <div *ngIf="!isOnboardingCompleted || !isInvoiceSettingsValid">
          <div style="display: flex; gap: 10px;">
            <app-svg source="icons/feather/square" *ngIf="stripeInfo?.stripeDashboardUrl == null"
              height="18px"></app-svg>
            <app-svg source="icons/feather/check-square" *ngIf="stripeInfo?.stripeDashboardUrl != null"
              height="18px"></app-svg>
            <h5
              [style]="stripeInfo?.stripeOnboardingUrl == null || stripeInfo?.stripeDashboardUrl == null ? 'color: crimson' : ''">
              <strong>Stripe Onboarding abschließen</strong>
            </h5>
          </div>
          <p i18n="@@CompleteStripeOnboardingMessage">Bitte schließen Sie das Stripe Onboarding ab, um Stripe als
            Zahlungsdienstleister zu aktivieren.</p>
          <p style="margin-top: -.5rem;">
            <button *ngIf="isOnboardingStarted && !isOnboardingCompleted" [disabled]="isSupporter"
              (click)="navigateTo(this.stripeInfo?.stripeOnboardingUrl)" class="btn btn-yellow">
              <app-svg source="icons/feather/external-link" height="18"></app-svg>
              <span i18n="@@OpenStripeOnboardingContinue">&ensp;Stripe Onboarding fortsetzen</span>
            </button>
            <button *ngIf="!isOnboardingStarted" [disabled]="isSupporter" (click)="createStripeAccount()"
              class="btn btn-yellow">
              <app-svg source="icons/feather/external-link" height="18"></app-svg>
              <span i18n="@@OpenStripeOnboardingBegin">&ensp;Stripe Onboarding beginnen</span>
            </button>
          </p>

          <div style="display: flex; gap: 10px;">
            <app-svg source="icons/feather/square" *ngIf="!isInvoiceSettingsValid" height="18px"></app-svg>
            <app-svg source="icons/feather/check-square" *ngIf="isInvoiceSettingsValid" height="18px"></app-svg>
            <h5 [style]="!isInvoiceSettingsValid ? 'color: crimson' : ''"><strong>Rechnungseinstellungen
                vornehmen</strong></h5>
          </div>
          <p i18n="@@CompleteInvoiceSettingsMessage">Bitte geben Sie die nötigen Angaben für Rechnungseinstellungen an,
            um die Erzeugung von Rechnungen zu ermöglichen.</p>
          <p style="margin-top: -.5rem;">
            <button *ngIf="!isInvoiceSettingsValid" [disabled]="isSupporter" [routerLink]="'/invoices/settings'"
              class="btn btn-yellow" i18n="@@OpenInvoiceSettingsButton">
              <app-svg source="icons/feather/sliders" height="18"></app-svg><span>&ensp;Rechnungseinstellungen</span>
            </button>
          </p>
        </div>
      </div>
    </div>

    <div class="card-footer d-flex gap-1" style="justify-content: right;">
      <button *ngIf="isTestingOrDevStage" class="btn btn-yellow" (click)="testMonthEnd()" [disabled]="isSupporter">
        <app-svg source="icons/feather/cash-out" height="18"></app-svg><span>&ensp;Sofort abrechnen</span>
      </button>

      <button *ngIf="isOnboardingCompleted" (click)="navigateTo(stripeInfo.stripeDashboardUrl)" id="go_stripe_dashboard"
        [disabled]="isSupporter" class="btn btn-yellow" i18n="@@OpenStripeDashboardButton">
        <app-svg source="icons/feather/external-link" height="18"></app-svg><span>&ensp;Stripe Dashboard aufrufen</span>
      </button>
    </div>
  </div>

  <!-- QR-Code-Laden -->
  <div class="active card" [style]="isOnboardingCompleted && isInvoiceSettingsValid ? '' : 'display: none'">
    <div class="card-header">
      <h5 i18n="@@QRCodePricingHeader"><app-svg source="icons/feather/qr-code" height="18"></app-svg>QR-Code-Laden</h5>
      <h5>
        <app-svg source="icons/feather/help-circle" height="18" i18n-ngbTooltip="@@QRCodePricingTooltip"
          [ngbTooltip]="tooltipContentQRCode" tooltipClass="tooltip custom-tooltip"></app-svg>
        <ng-template #tooltipContentQRCode>
          <div class="tooltip-content">
            Beim QR-Code-Laden erfolgen Rechnungsstellung und Abbuchung automatisch nach Beenden des Ladevorgangs. Die
            Nutzer
            (Gäste) können nach Abscannen des QR-Codes und eintragen ihrer E-Mail-Adresse mit Kreditkarte, Apple Pay,
            Google Pay und
            in Kürze PayPal bezahlen.
            <ul>
              <li>Der zu zahlende Mindestbetrag für einen angefangenen Ladevorgang beträgt 1 Euro.</li>
              <li>Der von Ihnen gewählte Tarif ist der Preis pro kWh inkl. Mehrwertsteuer, der auch dem Nutzer berechnet
                wird.</li>
              <li>Zur Zeit kann nur ein QR-Code-Tarif aktiv sein.</li>
              <li>Sie sollten etwa 30% auf Ihren Netto-Stromkostenbetrag aufschlagen, wenn Sie einen QR-Code-Tarif zum
                Selbstkostenpreis anbieten möchten.</li>
            </ul>
          </div>
        </ng-template>
      </h5>
    </div>

    <div class="card-body">
      <div *ngIf="stripeInfo?.stripeAccountId && !stripeInfo?.stripeOnboardingUrl && isInvoiceSettingsValid"
        class="pricings">
        <div *ngFor="let pricing of activeQRCodePricings" class="pricing" [routerLink]="'edit/' + pricing.id">
          <h2>{{ pricing.name }}</h2>
          <div class="prices d-flex gap-4">
            <div class="price ac"><span>AC</span>€&nbsp;{{ pricing.price | number: '1.2-2':'de-DE' }}</div>
            <div class="price dc"><span>DC</span>€&nbsp;{{ pricing.priceDc | number: '1.2-2':'de-DE' }}</div>
          </div>
          <p>{{ pricing.description }}</p>
          <span class="users">
            <app-svg source="icons/feather/users" height="18"></app-svg>
            {{pricing.selectedUsers.length || 0 }}
          </span>
        </div>
        <div class="pricing" (click)="isSupporter? null : setPricingType('QR-Code')" id="add_qrcode_pricing">
          <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
        </div>
      </div>
    </div>
  </div>

  <div class="card archive">
    <div class="card-header">
      <h5><app-svg source="icons/feather/tag" height="18" i18n="@@AllPricingHeader"></app-svg>Alle Tarife</h5>
      <h5>
        <app-svg source="icons/feather/help-circle" height="18" i18n-ngbTooltip="@@AllPricingTooltip"
          ngbTooltip="Tarife sind Gegenstand von Rechnungen und müssen daher langfristig gespeichert bleiben. Änderungen am Preis sind nachträglich nicht mehr möglich. Erstellen Sie neue Tarife um Preisänderungen umzusetzen."></app-svg>
      </h5>
    </div>

    <div class="card-body">
      <app-pricings-table [parent_operator]=this.isOperator></app-pricings-table>
    </div>

    <div class="card-footer" *ngIf="pricings && pricings.length > 10 && !this.isOperator">
      <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
    </div>
  </div>
</main>

<ng-template #loading>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center my-5">
        <div class="spinner-border text-primary loading-spinner-md">
          <span class="visually-hidden-focusable">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>

<ng-template #defaultFooter>
  <div class="d-flex">
    <div class="flex-fill d-none d-md-inline">
      <div class="d-flex">
        <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
        <div class="flex">
          <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
            class="form-control form-select custom-select" aria-label=""
            (change)="tableFunctions.onPageSizeChange('PricingsTableComponent')">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
      <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!" [(page)]="tableFunctions.page"
        [pageSize]="tableFunctions.pageSize" [maxSize]="tableFunctions.page == 4 ? 4 : 3" [boundaryLinks]="true"
        [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="flex-fill justify-content-end d-none d-md-inline">
      <div class="d-flex float-end">
        <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
        <div class="flex">
          <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
            aria-label="">
            <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1
              }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-template>